// extracted by mini-css-extract-plugin
module.exports = {"toggle_container":"Toggle_toggle_container__1LjGF","toggle_base":"Toggle_toggle_base__LRRTI"};